import {Provider} from 'react-redux' // redux
import store from './redux/store/store' // Redux
import { BrowserRouter as Router } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material/styles';

import rtlPlugin from 'stylis-plugin-rtl';
import { prefixer } from 'stylis';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import Content from './components/content/Content'
import './App.css'
import './App.scss'
//import TagManager from 'react-gtm-module'
import CookieBar from './components/CookieBar'

function App() {

  
const theme = createTheme({
  palette: {
    primary: {
      main: '#313280',
    },
  },
  typography: {
    fontSize: 14,
    button: {
      fontFamily: 'Spoiler-Regular',
      fontSize: '16px',
      fontWeight: 700
    }, 
  },
  direction: 'rtl', // Both here and <body dir="rtl">
});

/*const tagManagerArgs = {
    gtmId: 'GTM-PJWT5S3'
};*/

//TagManager.initialize(tagManagerArgs)
  
  
// Create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});
  return (
    <Router>
      <Provider store={store}>
         <CacheProvider value={cacheRtl}>
          <ThemeProvider theme={theme}>
              <div dir="rtl">
                <Content />
                <CookieBar />
              </div>
            </ThemeProvider>
          </CacheProvider>
      </Provider>
      {/* Google Tag Manager (body) */}
      <script>
        <noscript>
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5S43BNCM"
        height="0" width="0" style="display:none;visibility:hidden">
          </iframe>
        </noscript>
      </script>
      {/* End Google Tag Manager (body) */}
    </Router>
  )
}

export default App
